export default "__VITE_ASSET__Dtoze9et__"